var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.50025C0 0.37225 0.049 0.24425 0.146 0.14625C0.342 -0.04875 0.658 -0.04875 0.854 0.14625L8 7.29325L15.146 0.14625C15.342 -0.04875 15.658 -0.04875 15.854 0.14625C16.049 0.34225 16.049 0.65825 15.854 0.85425L8 8.70725L0.146 0.85425C0.049 0.75625 0 0.62825 0 0.50025Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDropdownArrow);
export default __webpack_public_path__ + "static/media/BlackDropdownArrow.20c81c705cb0f647bfb369c41df2d078.svg";
export { ForwardRef as ReactComponent };